// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"dd9d7a23","625":"1f73130e","980":"1f73130e"}[chunkId] + ".chunk.css";
};